/** @format */

import { createSlice } from '@reduxjs/toolkit';
import axios from 'src/utils/axios';
import { ENDPOINTS } from 'src/constants';
import type { CmsPageContent } from 'src/types';

const initialState = {
  publicContentInfo: null as CmsPageContent | null,
  loading: false,
  error: null as unknown
};

const slice = createSlice({
  name: 'publicContent',
  initialState,
  reducers: {
    getPublicContent(state) {
      state.loading = true;
      state.error = null;
    },
    getPublicContentSuccess(state, action) {
      const { data } = action.payload;
      state.publicContentInfo = data;
      state.loading = false;
    },
    getPublicContentFailure(state, action) {
      state.error = action.payload;
      state.loading = false;
    }
  }
});

export const reducer = slice.reducer;

export const getPublicContentInfo =
  (id: string | number, onSuccess: (data: unknown) => void, onFailure?: (err: unknown) => void) =>
  async dispatch => {
    const { getPublicContent, getPublicContentSuccess, getPublicContentFailure } = slice.actions;

    try {
      dispatch(getPublicContent());
      const response = await axios.get<CmsPageContent>(`${ENDPOINTS.GET_PUBLIC_CONTENT_INFO_ENDPOINT}/${id}`);
      dispatch(getPublicContentSuccess(response));
      onSuccess(response.data);
    } catch (err) {
      dispatch(getPublicContentFailure(err));
      // onFailure(err);
    }
  };

export const clearPublicContentError = () => dispatch => {
  dispatch(slice.actions.getPublicContentFailure(null));
};

export default slice;
